import { LoadingOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';
import { Trans } from 'react-i18next';

import { AIAlert } from '../components/AIAlert';
import { SinapseButton } from '../components/SinapseButton';
import { aiPurple } from '../constants/colors';
import { SparkIcon } from '../icons/spark';

interface PracticalTechnicalCaseGeneratorProps {
  loading?: boolean;
  disabled?: boolean;
  onGenerateClick?: () => void;
  confirmModal?: boolean;
  disabledMessage?: string;
}

const PracticalTechnicalCaseGenerator: React.FC<PracticalTechnicalCaseGeneratorProps> = ({
  loading,
  disabled,
  onGenerateClick,
  disabledMessage = '',
}) => {
  return (
    <AIAlert
      key="ai-alert-optimize-text"
      showIcon
      icon={<SparkIcon style={{ fontSize: '1.5em', color: aiPurple }} />}
      action={
        <Tooltip title={disabledMessage}>
          <SinapseButton
            type="primary"
            shape="round"
            disabled={disabled}
            onClick={onGenerateClick}
            size="large"
            loading={loading}
            icon={
              !loading ? (
                <SparkIcon animate={false} style={{ fontSize: '1em' }} />
              ) : (
                <LoadingOutlined />
              )
            }
          >
            {' '}
            <Trans>Gerar Case</Trans>
          </SinapseButton>
        </Tooltip>
      }
      message={
        <>
          <b>
            <Trans>Case prático ou técnico</Trans>:{' '}
          </b>
          <Trans>
            Utilize a Synapses, a inteligência artificial da Mindsight, para gerar automaticamente
            um case prático ou técnico alinhado aos requisitos da vaga.
          </Trans>
        </>
      }
    />
  );
};

export default PracticalTechnicalCaseGenerator;
